module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma/c1-434163fa5e46111cd9dd438f878d61d0.png";